export const calculeTotalProducts = (array: any) => {
  if (!array) return []
  return array.reduce((acc: any, cur: any) => {
    return (
      acc +
      (cur.salePrice - (cur.salePrice * (cur.additionalDiscount || 0)) / 100) *
        cur.quantity
    )
  }, 0)
}
